import loadable from '@loadable/component'

export default [
  {
    path: '/RedemptionMall/record',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-RedemptionMall-pages-record" */ '~/pages/RedemptionMall/pages/record'
        )
    ),
  },
  {
    path: '/RedemptionMall/rule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-RedemptionMall-pages-rule" */ '~/pages/RedemptionMall/pages/rule'
        )
    ),
  },
  {
    path: '/RedemptionMall/store',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-RedemptionMall-pages-store" */ '~/pages/RedemptionMall/pages/store'
        )
    ),
  },
  {
    path: '/RedemptionMall/guide',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-RedemptionMall-pages-guide" */ '~/pages/RedemptionMall/pages/guide'
        )
    ),
  },
  {
    path: '/RedemptionMall/staraward',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-RedemptionMall-modal-staraward" */ '~/pages/RedemptionMall/pages/StardAwardModal'
        )
    ),
  },
  {
    path: '/RedemptionMall/newUserAdvance',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-RedemptionMall-modal-newUserAdvance" */ '~/pages/RedemptionMall/pages/VipGiftsModal'
        )
    ),
  },
]
